import {Event} from "../Event";

export class GroupEvents extends Event {
  
}